import firebase from "./firebase";

const storage = firebase.storage();
export const gsGetUrl = (name) =>
  storage
    .refFromURL(`gs://komari-lieferung.appspot.com/komari/${name}`)
    .getDownloadURL()
    .catch((error) => {
      switch (error.code) {
        case "storage/object-not-found":
          // File doesn't exist
          console.error("Image is not in Firestorage: ", name);
          break;

        case "storage/unauthorized":
          // User doesn't have permission to access the object
          console.error("Unauthorized for ", name);
          break;
      }
    });
